@use '@shared/styles/media' as media;

.main {
  display: flex;
  flex-direction: column;

  &_hide-overflow {
    max-height: 100vh;
    overflow: hidden;
  }
}
